import React from 'react';

import './spinner.css';

export const Spinner = () => (
  <div>
    <span className="spinner material-symbols-outlined">progress_activity</span>
  </div>
);
